/* eslint-disable prettier/prettier */
import React from 'react';
import styled from 'styled-components';
import Box from '@material-ui/core/Box';

import { OrangeButton } from 'components/Button';
import { Captions, LongBody, SmallSectionHeader } from 'components/Typography';


const StyledBox = styled(({ isRadiusTop, ...otherProps }) => (
  <Box {...otherProps} />
))`
  border: 1px solid #e3e3e3;
  border-radius: ${(props) =>
    props.isRadiusTop ? '10px 10px 0 0' : '0px 0px 10px 10px'};
  border-top: ${(props) => (props.isRadiusTop ? '1px solid #E3E3E3' : 'none')};
`;

const GeneralConditions = styled.a`
  color: #1974fe;
  text-decoration: underline;
  cursor: pointer;
`;

const MemoIdBox = styled(Box)`
  p {
    margin: 0;
  }
`;


const StyledCaptions = styled(Captions)`
  margin-bottom: 0px !important;
`;

const StyledSmallSectionHeader = styled(SmallSectionHeader)`
  margin-bottom: 0px !important;
`;

const StyledBodyText = styled.p`
white-space: pre-line;
`;

const StyledOrangeButton = styled(OrangeButton)`
&& {
  margin-top: 30px;
  margin-bottom: 50px;
}
`;
 const SizedLongBody = styled(LongBody)`
  && {
    margin-bottom: 0px;
  }
`;

export {
  SizedLongBody,
  StyledBox,
  GeneralConditions,
  MemoIdBox,
  StyledCaptions,
  StyledSmallSectionHeader,
  StyledBodyText,
  StyledOrangeButton
};